import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import { ExchangeOrdersVisibilityPayload, ExchangeSettingPayload } from '../types/exchange-settings.type';

export const exchangeSettingsApi = createApi({
  reducerPath: 'exchangeSettingsApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/exchange-settings`),
  endpoints: (builder) => ({
    saveExchangeSettings: builder.mutation<ApiResponse<any>, ExchangeSettingPayload>({
      query: (payload) => ({
        url: `/update`,
        method: 'PUT',
        body: payload,
      }),
    }),
    updateExchangeOrdersVisibility: builder.mutation<ApiResponse<any>, ExchangeOrdersVisibilityPayload>({
      query: (payload) => ({
        url: `/show-orders-on-exchange`,
        method: 'PATCH',
        body: payload,
      }),
    }),
  }),
});

export const { useSaveExchangeSettingsMutation, useUpdateExchangeOrdersVisibilityMutation } = exchangeSettingsApi;
